import {
  IonAvatar,
  IonCheckbox,
  IonIcon,
  IonImg,
  IonItem
} from "@ionic/react";
import { Bot } from "../types/bot.type";
import ProfitIndicator from "./ProfitIndicator";
import UserName from "./UserName";
import { ReactComponent as TradesIcon } from "../assets/graphics/mode_heat.svg";
import { ReactComponent as StreaksIcon } from "../assets/graphics/mode_streaks.svg";
import EarningsIndicator from "./EarningsIndicator";
import { useLobbiesStore } from "../stores/lobbies.store";
import { useAuthStore } from "../stores/auth.store";
import { useGlobalsStore } from "../stores/globals.store";
import { chevronForward } from "ionicons/icons";

interface BotListItemProps {
  bot: Bot;
  index: number;
  hideEarnings?: boolean;
  selectable?: boolean;
  selected?: boolean;
  onSelect?: (bot: Bot) => void;
}

function getCoefficientIndex(numberOfBots: number) {
  const diff = numberOfBots % 5;
  if (diff === 0) {
    return numberOfBots;
  }
  return numberOfBots - diff + 5;
}

const BotListItem: React.FC<BotListItemProps> = ({
  bot,
  index,
  hideEarnings,
  selectable,
  selected,
  onSelect
}) => {
  const uid = useAuthStore(state => state.user?.uid);
  const payOutStructure = useGlobalsStore(
    state => state?.globals?.payOutStructure
  );
  const lobby = useLobbiesStore(
    state => bot?.lobby && state?.lobbies?.find(l => l.id === bot.lobby)
  );
  if (lobby && !hideEarnings) {
    if (lobby?.challenge && !lobby?.ended) {
      // calculate the earnings based on the index
      // const prizeMoney = lobby.quoCoin * payoutStructure.prize;
      const totalToBePaid = (lobby.quoCoin ?? 0) * payOutStructure.payOut;
      const payOutIndex = getCoefficientIndex(5);
      const payoutCoefficients =
        payOutStructure.positionCoefficient[payOutIndex];
      bot.earnings = parseFloat(
        (totalToBePaid * (payoutCoefficients[index] || 0)).toFixed(2)
      );
    } else {
      bot.earnings =
        lobby?.standings?.find(s => s.botId === bot.id)?.earnings || 0;
    }
  }
  return (
    <IonItem
      className="ion-no-padding"
      lines="none"
      detail={false}
      routerLink={!selectable ? `/bots/${bot.id}` : undefined}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <div
        className={`flex py-2 border-b border-primary-80 rounded ml-2 w-full ${
          !selectable && bot?.lobby && bot?.user === uid
            ? "bg-primary-70"
            : "bg-primary-90"
        }`}
      >
        <IonAvatar className="h-12 w-12">
          <IonImg src={bot?.img} className="h-12 w-12" />
          {bot?.lobby && (
            <span className="absolute -mt-12 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
              {index + 1}
            </span>
          )}
          {
            <span className="absolute -mt-4">
              <IonImg
                className="w-4 h-4"
                src={`https://raw.githubusercontent.com/cjdowner/cryptocurrency-icons/master/128/icon/${bot?.quoteAsset?.toLowerCase()}.png`}
              />
            </span>
          }
        </IonAvatar>
        <div className="flex flex-col justify-center px-1 text-sm w-[84px]">
          {bot?.name?.substring(0, 10)}
          <UserName small userId={bot?.user} />
        </div>
        <div className="flex items-center ml-auto mr-0 gap-x-2">
          <div className="flex text-xs text-white w-[32px]">
            <div className="bg-[#ff7f0a] opacity-70 p-[2px] rounded h-4 mr-1">
              <TradesIcon />
            </div>
            {bot?.tradeCount || 0}
          </div>
          <div className="text-xs text-white flex w-[44px]">
            <StreaksIcon /> {bot?.profitStreak || 0}/{bot?.maxProfitStreak || 0}
          </div>
          <div className="w-[60px] flex justify-center">
            <ProfitIndicator profit={bot?.profit} />
          </div>

          <div className="w-[48px] flex justify-center">
            {!hideEarnings && (
              <EarningsIndicator earnings={(lobby && bot?.earnings) || 0} />
            )}
          </div>
          {selectable ? (
            <IonCheckbox
              mode="md"
              className="-ml-12"
              checked={selected}
              onIonChange={e => {
                e.stopPropagation();
                onSelect && onSelect(bot);
              }}
            />
          ) : (
            <IonIcon icon={chevronForward} className="text-primary-50" />
          )}
        </div>
      </div>
    </IonItem>
  );
};

export default BotListItem;
